import { render, staticRenderFns } from "./selectCard.vue?vue&type=template&id=5bc59822&scoped=true&"
import script from "./selectCard.vue?vue&type=script&lang=js&"
export * from "./selectCard.vue?vue&type=script&lang=js&"
import style0 from "./selectCard.vue?vue&type=style&index=0&id=5bc59822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc59822",
  null
  
)

export default component.exports